<template>
    <p>Filtrar por Tipo Solicitud:</p>
    <v-autocomplete
        v-model="tiposSolicitudValues"
        :items="tiposSolicitudes"
        item-title="nombre"
        item-value="valor"
        label="Tipo Solicitud"
        variant="solo"
        density="compact"
        hide-details
        clearable
        multiple
        chips
        @update:modelValue="this.$emit('selectTiposSolicitudes', tiposSolicitudValues)"
    ></v-autocomplete>
    <AlertComponent
        :title="alertTitle"
        :text="alertText"
        :alertType="alertType"
        :showAlert="showAlert"
        @close="showAlert = false"
    ></AlertComponent>
</template>
<style src="../assets/general.css"></style>
<script>
    import PrestacionService from '@/api/PrestacionService';
    import AlertComponent from './AlertComponent.vue';

    const prestacionService = new PrestacionService();

    export default {
        components:{
            AlertComponent
        },
        data() {
            return {
                tiposSolicitudValues: [],
                tiposSolicitudes: [],
                cargandoTiposSolicitudes: false,
                //datos alert
                alertTitle: '',
                alertText: '',
                alertType: '',
                showAlert: false
            }
        },
        methods: {
            async getTiposSolicitudes() {
                this.cargandoTiposSolicitudes = true;
                this.tiposSolicitudes = [];
                this.tiposSolicitudValues = [];
                const response = await prestacionService.getTiposSolicitud();
                if(response && response.status === 200) {
                    this.tiposSolicitudes = response.data;
                } else {
                    this.alertTitle = 'Error';
                    this.alertText = 'No se encontró el usuario';
                    this.alertType = 'error';
                    this.showAlert = true;
                }
                this.cargandoTiposSolicitudes = false;
            },
            limpiarSeleccion(){
                this.tiposSolicitudValues = [];
            }
        },
        async mounted() {
            await this.getTiposSolicitudes();
        }   
    }
</script>